import React, { useEffect, useState } from 'react';

interface OwnProps {
  time: number;
  timeUp: () => void;
}

type Props = OwnProps;

const Timer = (props: Props) => {
  const [time, setTime] = useState(props.time);

  useEffect(() => {
    const timer = setInterval(() => {
      let newTime;
      setTime((prevTime) => {
        newTime = prevTime - 1;
        return newTime;
      });
      if (newTime === 0) {
        clearInterval(timer);
        props.timeUp();
      }
    }, 1000);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);

  return <span>{time}s</span>;
};

export default Timer;
